export default "__VITE_ASSET__C0hpSQU1__"